module.exports = (array) =>
  array.sort((a, b) => new Date(b.node.frontmatter.date) - new Date(a.node.frontmatter.date));
